/**
 * @ngdoc directive
 * @name cbl.insuranceloanpmi.mf.directive:creasRiepilogoPolizze
 * @restrict E
 * @description Componente che gestisce il terzo sotto-step "Riepilogo Polizze" dello step "Pagamento"
 */
(function() {
	"use strict";
	var CreasRiepilogoPolizzeCtrl = function($http, $scope, $state, $stateParams, $window, $q, $httpParamSerializer, $uibModal, CONSTANTS, labelSrvc, messaggiFctr, dettPraticaSrvc) {
		this.$http = $http;
		this.$state = $state;
		this.$stateParams = $stateParams;
		this.$window = $window;
		this.$uibModal = $uibModal;
		this.messaggiFctr = messaggiFctr;
		this.dettPraticaSrvc = dettPraticaSrvc;
		this.CONSTANTS = CONSTANTS;
		$scope.msg = labelSrvc.getLabel;
		
		// Spinner
	    this.spinner = dettPraticaSrvc.spinner;

		var self = this;
		
		// Configuro l'abilitazione dei pulsanti di scorrimento tra gli step	
		dettPraticaSrvc.isCancelFinanziamentoVisible = function() {
	      return true;
	    };
	    dettPraticaSrvc.isCancelFinanziamentoEnabled = function() {
	      return true;
	    };
		dettPraticaSrvc.isSaveEnabled = function() {
			return self.dettPraticaSrvc.finanziamento.elencoPolizze && self.dettPraticaSrvc.finanziamento.elencoPolizze.length > 0;
		}
		
		dettPraticaSrvc.isPrevEnabled = function() {
			return true;
		}
		
		dettPraticaSrvc.isNextEnabled = function() {
			return self.dettPraticaSrvc.finanziamento.elencoPolizze && self.dettPraticaSrvc.finanziamento.elencoPolizze.length > 0;
		}
		
		// Configuro il comportamento del pulsante prosegui per lo step
	    dettPraticaSrvc.nextStep = function() {
			
			if (!self.dettPraticaSrvc.finanziamento) {
				return;
			}
			
			if (self.dettPraticaSrvc.verificaImportiPolizze() !== true) {
				return;
			}
			
			// Richiedo conferma prima di proseguire con l'avanzamento di step
		      var modalController = function($scope, LabelSrvc, $modalInstance) {
			      $scope.headerText = LabelSrvc.getLabel(
			        'label.riepilogopolizze.confermaavanti.header'
			      );
			      $scope.bodyText = LabelSrvc.getLabel(
			        'label.riepilogopolizze.confermaavanti.content'
			      );
			      $scope.cancelText = LabelSrvc.getLabel(
			        'label.riepilogopolizze.confermaavanti.cancel'
			      );
			      $scope.confirmText = LabelSrvc.getLabel(
			        'label.riepilogopolizze.confermaavanti.confirm'
			      );
			
			      $scope.optionSelected = function(result) {
			        $modalInstance.close(result);
			      };
			    };
			
			    modalController.$inject = ['$scope', 'LabelSrvc', '$modalInstance'];
			
			    var modalInstance = self.$uibModal.open({
			      animation: true,
			      template:
			        '<creas-confirm-modal header-text="headerText" body-text="bodyText" cancel-text="cancelText" confirm-text="confirmText" option-selected="optionSelected(result)"></creas-confirm-modal>',
			      backdrop: 'static',
			      size: 'lg',
			      controller: modalController
			    });
			
			    modalInstance.result.then(function(confirmResult) {
			      if (confirmResult !== true) {
			        return;
			      }
					// SALVATAGGIO POLIZZE
					self.spinner.pratica = true;
					
					$q
					.all({salvaPolizze: self.dettPraticaSrvc.promiseSalvaPolizze()})
					.then(
					  function(response) {
						  if (response.salvaPolizze.data.result) {
				            $q
				              .all({
				                nextStep: self.dettPraticaSrvc.promiseCambiaStep('/avantiStep')
				              })
				              .then(
				                function(response) {
				                  if (self.messaggiFctr.processaResponse(response.nextStep)) {
				                    return;
				                  }
				                  
				                  self.dettPraticaSrvc.datiPratica = response.nextStep.data.result;
				                  dettPraticaSrvc.generaTabs();
				                },
				                function(reason) {
				                  self.messaggiFctr.processaResponse(reason.nextStep);
				                }
				              )
				              .finally(function() {
				                self.spinner.pratica = false;
				              });
				          } else {
				            self.spinner.pratica = false;
				          }
					  },
					  function(reason) {
					    self.messaggiFctr.processaResponse(reason.salvaPolizze);
					    self.spinner.pratica = false;
					  }
					);
			    });
	    };

	    // Configuro il comportamento del pulsante salva per lo step
		dettPraticaSrvc.salva = function() {
				
			if (self.dettPraticaSrvc.verificaImportiPolizze() !== true) {
				return;
			}
			
			self.spinner.pratica = true;
			  
			$q
			.all({salvaPolizze: self.dettPraticaSrvc.promiseSalvaPolizze()})
			.then(
				function(response) {
					self.dettPraticaSrvc.finanziamento = response.salvaPolizze.data.result;
					if (self.messaggiFctr.processaResponse(response.salvaPolizze)) {
						return;
					}
				},
				function(reason) {
					self.messaggiFctr.processaResponse(reason.salvaPolizze);
				}
			)
			.finally(function() {
				self.spinner.pratica = false;
			});
			
		};
		
		/**
		 * @ngdoc method
		 * @name rimuoviTitolo
		 * @methodOf cbl.insuranceloanpmi.mf.directive:creasRiepilogoPolizze
		 * @description Rimuove il titolo selezionato da quelli aggiunti alla pratica
		 * @param {Object} titolo - Il titolo da rimuovere
		 */
		this.rimuoviTitolo = function(titolo) {
			var itemIndex = self.dettPraticaSrvc.finanziamento.elencoPolizze.indexOf(titolo);
			
			if (itemIndex === -1) {
				return;
			}
			
			self.dettPraticaSrvc.finanziamento.elencoPolizze.splice(itemIndex, 1);
			self.aggiornaTitoli();
		}
		
		/**
		 * @ngdoc method
		 * @name aggiornaTitoli
		 * @methodOf cbl.insuranceloanpmi.mf.directive:creasRiepilogoPolizze
		 * @description Aggiorna la visualizzazione dell'elenco dei titoli aggiunti
		 */
		this.aggiornaTitoli = function() {
			self.dettPraticaSrvc.finanziamento.elencoPolizze = self.dettPraticaSrvc.finanziamento.elencoPolizze.concat([]);
		}
		
		/**
		 * @ngdoc method
		 * @name recuperaTotaleTitoli
		 * @methodOf cbl.insuranceloanpmi.mf.directive:creasRiepilogoPolizze
		 * @description Calcola e mostra il totale dei titoli selezionati
		 */
		this.recuperaTotaleTitoli = function() {			
			var totaleTitoli = 0;
			
			if (self.dettPraticaSrvc.finanziamento.elencoPolizze && self.dettPraticaSrvc.finanziamento.elencoPolizze.length > 0) {
				for(var i = 0; i < self.dettPraticaSrvc.finanziamento.elencoPolizze.length; i++) {
					totaleTitoli += self.dettPraticaSrvc.finanziamento.elencoPolizze[i].datiPagamento.importoPremioLordo;
				}
			}
			
			return totaleTitoli;
		}
		
		/**
		 * @ngdoc method
		 * @name mostraTitoliSalvati
		 * @methodOf cbl.insuranceloanpmi.mf.directive:creasRiepilogoPolizze
		 * @description Recupera i titoli salvati nella pratica e li mostra tra quelli selezionati
		 */
		this.mostraTitoliSalvati = function() {
			self.dettPraticaSrvc.finanziamento = self.dettPraticaSrvc.getFinanziamentoBozza();
			
			if (!self.dettPraticaSrvc.finanziamento) {
				return;
			}
			
			if (!self.dettPraticaSrvc.finanziamento.elencoPolizze) {
				return;
			}
			
			self.aggiornaTitoli();
		}
		
		this.mostraTitoliSalvati();

		
	};

	CreasRiepilogoPolizzeCtrl.$inject = [ '$http', '$scope', '$state', '$stateParams', '$window', '$q', '$httpParamSerializer', '$uibModal', 'CONSTANTS', 'LabelSrvc', 'CreasMessaggiFctr', 'CreasDettaglioPraticaSrvc' ];

	var TemplateUrl = function(CONSTANTS) {
		return CONSTANTS.BASE_ROOT + CONSTANTS.COMPONENTS_PATH + "creasDettaglioPratica/creasPraticaPagamento/creasRiepilogoPolizze/creasRiepilogoPolizze.html";
	}

	TemplateUrl.$inject = [ 'CONSTANTS' ];

	var CreasRiepilogoPolizzeComponent = {
		bindings : {},
		controller : CreasRiepilogoPolizzeCtrl,
		controllerAs : "creasRiepilogoPolizzeCtrl",
		templateUrl : TemplateUrl
	};

	angular.module("cbl.insuranceloanpmi.mf").component("creasRiepilogoPolizze", CreasRiepilogoPolizzeComponent);
}());


//////////////////
// WEBPACK FOOTER
// ./app/components/creasDettaglioPratica/creasPraticaPagamento/creasRiepilogoPolizze/creasRiepilogoPolizze.cmpt.js
// module id = 29
// module chunks = 0 1